<template>
  <div>
    <modal
      :open="open"
      :title="trans('attendance_list.enable')"
      style="text-align:left; "
      @close="closeModal"
    >
      <p>
        {{ trans('attendance_list.enable_explanation') }}
      </p>
      <button
        type="button"
        class="btn btn-default pull-right"
        @click="closeModal"
      >
        {{ trans('core.cancel') }}
      </button>

      <button
        type="button"
        class="btn btn-success pull-right"
        @click="openAttendanceList"
      >
        {{ trans('attendance_list.start_registration') }}
      </button>

      <br style="clear:both">
    </modal>
  </div>
</template>

<script>

import Modal from './Modal.vue'
import toast from '../../../services/toast'
import { defaultErrorMessage } from '@/helpers'

export default {

  name: 'AttendanceListEnableModal',

  components: { Modal },

  props: {
    attendanceData: {
      required: true,
    },
    type: {
      required: true,
    },
  },

  data () {
    return {
      open: false,
    }
  },

  computed: {},

  watch: {},

  mounted () {
    this.openModal()
  },

  methods: {
    openModal () {
      this.open = true
    },

    closeModal () {
      this.remark = null
      this.open = false
      this.$emit('closed-modal')
    },

    openAttendanceList () {
      this.$store.dispatch('set_enable_attendance_list', { registrationEnabled: true })

      // single registration
      if (this.type == 'single') {
        if (this.attendanceData != null && Object.keys(this.attendanceData).length == 5) {
          this.$store.dispatch('change_loading', { loading: true }).then(() => {
            this.disabled = true

            return this.$store.dispatch('change_attendance', this.attendanceData).catch(error => defaultErrorMessage(error))
          }).then(() => {
            this.disabled = false
            this.$store.dispatch('change_loading', { loading: false })
            this.closeModal()
          })
        } else {
          return toast.error(Lang.get('errors.message.invalid_parameter'))
        }
      } else if (this.type == 'all') {
        this.$emit('selectAll')
        this.closeModal()
      } else {
        this.closeModal()
      }
    },
  },
}
</script>

<style>

</style>
